import { render, staticRenderFns } from "./TitleAndSubtitle.vue?vue&type=template&id=3878a805"
import script from "./TitleAndSubtitle.vue?vue&type=script&lang=js"
export * from "./TitleAndSubtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports